export const regexEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const regexNotNumber = /[^0-9]/g;
export const regexPhoneNumber = /^(01[016789]{1})(\d{0,4})(\d{0,4})$/g;
